import React from 'react';
import { Button } from '../../components/Button';
import { Card } from '../../components/Card';
import { Label } from '../../components/Form';
import { saveAs } from 'file-saver';
import ReactStoreIndicator from 'react-score-indicator'

const ODSSelectScreen = ({ ods, onChange, onSelectAll, values }) => {
  return <Card className="ods-screen" style={{ width: "100%" }}>
    <div className='ods-screen-title'>{`Gerar relatório de impacto`.toLocaleUpperCase()}</div>
    {ods.map(odsItem => <div className='ods-item'>
      <ODSLabel onSelectAll={onSelectAll} {...odsItem} codes={odsItem.indicators.map(item => item.questions.map(item => item.code)).flat()} />
      {odsItem.indicators.map(indicator => <div className='ods-item ods-indicator'>
        <ODSIndicator {...indicator} />
        {indicator.questions.map(question => <div className='ods-item ods-indicator'>
          <ODSQuestion ods={odsItem.title} indicator={indicator.title} values={values} onChange={onChange} {...question} />
        </div>)}
      </div>)}
    </div>)}
    <Button label={`Gerar Configuração - ${Object.keys(values).filter(key => values[key]).length} Indicadore(s)`} handleClick={() => {
      var file = new File([JSON.stringify(values)], "projeto.json", { type: "application/json;charset=utf-8" });
      saveAs(file, "projeto.json")
    }} />
  </Card>
}

function getRandomArbitrary(min, max) {
  return Math.random() * (max - min) + min;
}

export const ODSLabel = ({ onSelectAll, icon, odsIndex, title, codes }) => {
  return <div className='ods-label-container'>
    <div><img className='ods-image' src={icon} /></div>
    <div className='ods-title'>{`${title}`.toLocaleUpperCase()}</div>
    {onSelectAll ? <a href="#" className='ods-link' onClick={() => {
      const data = {};
      codes.map(key => data[key] = true);
      onSelectAll(data)
    }}>Selecionar todos</a> : <ReactStoreIndicator
      lineWidth={10}
      value={(((odsIndex + 1) * 78) % 100).toFixed(1)}
      maxValue={100}
    />}
  </div>
}

export const ODSIndicator = ({ title }) => {
  return <div className='indicator-label-container'>
    <div className='indicator-title'>{title}</div>
  </div>
}

export const ODSQuestion = ({ ods, indicator, values, onChange, code, title }) => {
  return <div className='indicator-label-container'>
    <input
      type="checkbox"
      checked={values[code]}
      className="checkbox-input"
      onChange={(e) => onChange(code, e.target.checked)}
    />
    <div className='indicator-title'><b>{code}</b>{" - " + title}</div>
  </div>
}

export default ODSSelectScreen;